

export default {
  locale: 'nl-be',
  Pagination: {
    items_per_page: '/ pagina',
    jump_to: 'Ga naar',
    jump_to_confirm: 'bevestigen',
    page: '',
    prev_page: 'Vorige pagina',
    next_page: 'Volgende pagina',
    prev_5: "Vorige 5 pagina's",
    next_5: "Volgende 5 pagina's",
    prev_3: "Vorige 3 pagina's",
    next_3: "Volgende 3 pagina's",
    page_size: 'Page Size'
  },
  DatePicker: {
    lang: {
      placeholder: 'Selecteer datum',
      rangePlaceholder: ['Begin datum', 'Eind datum'],
      locale: 'nl_BE',
      today: 'Vandaag',
      now: 'Nu',
      backToToday: 'Terug naar vandaag',
      ok: 'Ok',
      clear: 'Reset',
      month: 'Maand',
      year: 'Jaar',
      timeSelect: 'Selecteer tijd',
      dateSelect: 'Selecteer datum',
      monthSelect: 'Kies een maand',
      yearSelect: 'Kies een jaar',
      decadeSelect: 'Kies een decennium',
      yearFormat: 'YYYY',
      dateFormat: 'D-M-YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D-M-YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Vorige maand (PageUp)',
      nextMonth: 'Volgende maand (PageDown)',
      previousYear: 'Vorig jaar (Control + left)',
      nextYear: 'Volgend jaar (Control + right)',
      previousDecade: 'Vorig decennium',
      nextDecade: 'Volgend decennium',
      previousCentury: 'Vorige eeuw',
      nextCentury: 'Volgende eeuw',
      monthPlaceholder: 'Selecteer maand',
      quarterPlaceholder: 'Selecteer kwartaal',
      rangeMonthPlaceholder: ['Begin maand', 'Eind maand'],
      rangeWeekPlaceholder: ['Begin week', 'Eind week'],
      rangeYearPlaceholder: ['Begin jaar', 'Eind jaar'],
      weekPlaceholder: 'Selecteer week',
      yearPlaceholder: 'Selecteer jaar'
    },
    timePickerLocale: {
      placeholder: 'Selecteer tijd',
      rangePlaceholder: ['Start tijd', 'Eind tijd']
    }
  },
  TimePicker: {
    placeholder: 'Selecteer tijd',
    rangePlaceholder: ['Start tijd', 'Eind tijd']
  },
  Calendar: {
    lang: {
      placeholder: 'Selecteer datum',
      rangePlaceholder: ['Begin datum', 'Eind datum'],
      locale: 'nl_BE',
      today: 'Vandaag',
      now: 'Nu',
      backToToday: 'Terug naar vandaag',
      ok: 'Ok',
      clear: 'Reset',
      month: 'Maand',
      year: 'Jaar',
      timeSelect: 'Selecteer tijd',
      dateSelect: 'Selecteer datum',
      monthSelect: 'Kies een maand',
      yearSelect: 'Kies een jaar',
      decadeSelect: 'Kies een decennium',
      yearFormat: 'YYYY',
      dateFormat: 'D-M-YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D-M-YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Vorige maand (PageUp)',
      nextMonth: 'Volgende maand (PageDown)',
      previousYear: 'Vorig jaar (Control + left)',
      nextYear: 'Volgend jaar (Control + right)',
      previousDecade: 'Vorig decennium',
      nextDecade: 'Volgend decennium',
      previousCentury: 'Vorige eeuw',
      nextCentury: 'Volgende eeuw',
      monthPlaceholder: 'Selecteer maand',
      quarterPlaceholder: 'Selecteer kwartaal',
      rangeMonthPlaceholder: ['Begin maand', 'Eind maand'],
      rangeWeekPlaceholder: ['Begin week', 'Eind week'],
      rangeYearPlaceholder: ['Begin jaar', 'Eind jaar'],
      weekPlaceholder: 'Selecteer week',
      yearPlaceholder: 'Selecteer jaar'
    },
    timePickerLocale: {
      placeholder: 'Selecteer tijd',
      rangePlaceholder: ['Start tijd', 'Eind tijd']
    }
  },
  Table: {
    filterTitle: 'Filteren',
    filterConfirm: 'OK',
    filterReset: 'Reset',
    selectAll: 'Selecteer huidige pagina',
    selectInvert: 'Keer volgorde om',
    cancelSort: 'Klik om sortering te annuleren',
    collapse: 'Rij inklappen',
    emptyText: 'Geen data',
    expand: 'Rij uitklappen',
    filterEmptyText: 'Geen filters',
    selectNone: 'Maak selectie leeg',
    selectionAll: 'Selecteer alle data',
    sortTitle: 'Sorteren',
    triggerAsc: 'Klik om oplopend te sorteren',
    triggerDesc: 'Klik om aflopend te sorteren'
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Annuleer',
    justOkText: 'OK'
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Annuleer'
  },
  Transfer: {
    searchPlaceholder: 'Zoek hier',
    itemUnit: 'item',
    itemsUnit: 'items',
    remove: 'Verwijder',
    removeAll: 'Verwijder alles',
    removeCurrent: 'Verwijder huidige pagina',
    selectAll: 'Selecteer alles',
    selectCurrent: 'Selecteer huidige pagina',
    selectInvert: 'Huidige pagina omkeren',
    titles: ['', '']
  },
  Upload: {
    uploading: 'Uploaden...',
    removeFile: 'Verwijder bestand',
    uploadError: 'Fout tijdens uploaden',
    previewFile: 'Preview file',
    downloadFile: 'Bestand downloaden'
  },
  Empty: {
    description: 'Geen gegevens'
  },
  global: {
    placeholder: 'Maak een selectie'
  },
  Icon: {
    icon: 'icoon'
  },
  Text: {
    edit: 'Bewerken',
    copy: 'kopiëren',
    copied: 'Gekopieerd',
    expand: 'Uitklappen'
  },
  PageHeader: {
    back: 'Terug'
  },
  Image: {
    preview: 'Voorbeeld'
  }
};
